import React, { FCC } from 'react';
import posed from 'react-pose';
import { IModalBackdropProps } from './types';

const TRANSITION_DURATION = 200;

const PosedDiv = posed.div({
  enter: {
    opacity: 0.5,
    transition: {
      duration: TRANSITION_DURATION,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: TRANSITION_DURATION,
    },
  },
});

/**
 * Implements behavior of Bootstrap's backdrop
 */
export const ModalBackdrop: FCC<IModalBackdropProps> = (props) => {
  const { onHide, zIndex, ...restProps } = props;
  const style = zIndex ? { zIndex } : {};

  return (
    <PosedDiv
      initialPose="exit"
      style={style}
      className={`modal-backdrop in`}
      onClick={onHide}
      qa-id={props['qa-id']}
      {...restProps}
    />
  );
};
